(function () {
  function closeOpenOverviewMenus() {
    document
      .querySelectorAll('.et-update-meals-overview-slot__menu[open]')
      .forEach(function (el) {
        el.removeAttribute('open');
      });
  }

  function handleOverviewMenuCloseOnOutsideClick(event) {
    const target = event && event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('.et-update-meals-overview-slot__menu')) return;
    closeOpenOverviewMenus();
  }

  function handleOverviewMenuCloseOnEscape(event) {
    if (event && event.key === 'Escape') closeOpenOverviewMenus();
  }

  window.etRechargeMenuToggle = {
    closeOpenOverviewMenus: closeOpenOverviewMenus,
    handleOverviewMenuCloseOnOutsideClick: handleOverviewMenuCloseOnOutsideClick,
    handleOverviewMenuCloseOnEscape: handleOverviewMenuCloseOnEscape,
  };

  function installMenuToggleListenersWhenReady() {
    document.addEventListener('click', handleOverviewMenuCloseOnOutsideClick);
    document.addEventListener('keydown', handleOverviewMenuCloseOnEscape);
  }

  installMenuToggleListenersWhenReady();
})();
